import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { Step } from 'react-joyride';
import { NavigateFunction } from 'react-router-dom';
import { getStepTarget } from '../../lib/getStepTarget';
import { TOUR_STEP_IDS } from './tourStepIds';
import { getPurchaseItemLocation } from '../../lib/getPurchaseItemLocation';
import { moveToAcceptanceItem } from '../../lib/moveToAcceptanceItem';
import { moveToShipmentItem } from '../../lib/moveToShipmentItem';
import { queryClient } from '@fsd/shared/lib/react-query/queryClient';
import { getAccountCabinetOnboardingDataStatus } from '@fsd/entities/onboarding/api/getAccountCabinetOnboardingDataStatus/getAccountCabinetOnboardingDataStatus';
import { onboardingStore } from '@fsd/entities/onboarding/model/store/onboardingStore';
import { accountCabinetOnboardingProgress } from '@fsd/entities/onboarding/api/accountCabinetOnboardingProgress/accountCabinetOnboardingProgress';

type OnboardingRouteStep = Step & { route?: string };

const withRoute = (route: string, step: Step): OnboardingRouteStep => ({
  ...step,
  route,
});

export const tourSteps: (navigate: NavigateFunction) => Step[] = (
  navigate: NavigateFunction
) => [
  ///////
  // First Part
  ///////

  // {
  //   id: TOUR_STEP_IDS.CHECKLIST_BUTTON,
  //   target: getStepTarget(TOUR_STEP_IDS.CHECKLIST_BUTTON),
  //   width: '450px',
  //   content: (
  //     <>
  //       <p>
  //         Мы подготовили чек-лист. Он проведёт вас по всем шагам и покажет
  //         прогресс настройки.
  //       </p>
  //       <p>
  //         Вы всегда можете прервать настройку и вернуться к ней позже. Для
  //         продолжения кликайте на кнопку чек-листа и жмите “Запуск настройки”
  //         повторно. Настройка продолжится.
  //       </p>
  //       <p>
  //         Будьте внимательны. В списке есть данные, достоверность которых
  //         зависит только от данных, которые вы ввели самостоятельно. Немного
  //         дисциплины и вы - у цели!
  //       </p>
  //     </>
  //   ),
  //   data: {
  //     next: routes.organisations.path,
  //   },
  // },
  withRoute(routes.organisations.path, {
    before: async () => {
      const clicked = !!localStorage.getItem('clicked');

      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }

      if (!clicked) {
        const element = document.querySelector(
          `${getStepTarget(TOUR_STEP_IDS.DATE_ROW_CALENDAR)} ${getStepTarget(
            TOUR_STEP_IDS.CALENDAR_BUTTON
          )}`
        );
        if (element) {
          (element as HTMLElement)?.click();
          localStorage.setItem('clicked', 'true');
        }
      }
    },
    after: async () => {
      const clicked = !!localStorage.getItem('clicked');
      if (clicked) {
        const element = document.querySelector(
          `${getStepTarget(TOUR_STEP_IDS.DATE_ROW_CALENDAR)} ${getStepTarget(
            TOUR_STEP_IDS.CALENDAR_BUTTON
          )}`
        );
        if (element) {
          (element as HTMLElement)?.click();
          localStorage.removeItem('clicked');
        }
      }
    },
    id: TOUR_STEP_IDS.START_DATE,
    target: `${getStepTarget(TOUR_STEP_IDS.DATE_ROW_CALENDAR)} ${getStepTarget(
      TOUR_STEP_IDS.MONTH_PICKER
    )}`,
    title: 'Дата начала учета',
    overlayClickAction: false,

    width: '330px',
    content: <></>,
  }),
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.ORGANISATION,
    target: getStepTarget(TOUR_STEP_IDS.ORGANISATION),
    overlayClickAction: false,
    title: 'Организация',
    width: '335px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }
    },
    id: TOUR_STEP_IDS.TAXES,
    target: getStepTarget(TOUR_STEP_IDS.TAXES),
    overlayClickAction: false,
    title: 'Налогообложение',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }

      const element = document.querySelector(
        `${getStepTarget(TOUR_STEP_IDS.TAXES_DATE)} ${getStepTarget(
          TOUR_STEP_IDS.CALENDAR_BUTTON
        )}`
      );
      (element as HTMLElement)?.click();
    },
    id: TOUR_STEP_IDS.TAXES_DATE,
    target: `${getStepTarget(TOUR_STEP_IDS.TAXES_DATE)} ${getStepTarget(
      TOUR_STEP_IDS.MONTH_PICKER
    )}`,
    overlayClickAction: false,
    title: 'Дата налогообложения',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }

      const element = document.querySelector(
        '[data-testid="create-mp-button"]'
      );
      (element as HTMLElement)?.click();
    },
    id: TOUR_STEP_IDS.SELECT_MARKETPLACE,
    target: getStepTarget(TOUR_STEP_IDS.SELECT_MARKETPLACE),
    overlayClickAction: false,
    title: 'Выбрать Маркетплейсы',

    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }
    },
    id: TOUR_STEP_IDS.MARKETPLACE_API,
    target: getStepTarget(TOUR_STEP_IDS.MARKETPLACE_API),
    overlayClickAction: false,
    title: 'API Маркетплейсы',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }

      const element = document.querySelector(
        '[data-testid="create-bank-button"]'
      );
      (element as HTMLElement)?.click();
    },
    id: TOUR_STEP_IDS.SELECT_BANK,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.SELECT_BANK),
    title: 'API Банки',

    width: '435px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }
    },
    id: TOUR_STEP_IDS.BANKS_API,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_API),
    title: 'API Банки',
    width: '435px',
    content: <></>,
  },
  {
    id: TOUR_STEP_IDS.SAVE_SETTINGS,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.SAVE_SETTINGS),
    title: 'Сохранение',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.organisations.path) {
        navigate(routes.organisations.path);
      }

      const data = await queryClient.fetchQuery({
        queryKey: ['onboarding-data-status'],
        queryFn: getAccountCabinetOnboardingDataStatus,
      });

      if (!data.data.pnl_report_done)
        onboardingStore.setStepIndex(onboardingStore.currentStepIndex + 1);
    },
    id: TOUR_STEP_IDS.FIRST_STAGE_FINISH,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Первый этап завершён!',
    width: '330px',
    content: <></>,
    data: {
      next: routes.warehouses.path,
    },
  },

  ///////
  // Second Part
  ///////
  {
    before: async () => {
      if (window.location.pathname !== routes.warehouses.path) {
        navigate(routes.warehouses.path);
      }
    },
    id: TOUR_STEP_IDS.STAGE_2_INTRO,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Этап 2',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.warehouses.path) {
        localStorage.setItem('tour_current_step', TOUR_STEP_IDS.WAREHOUSES);
        navigate(routes.warehouses.path);
      }
    },
    id: TOUR_STEP_IDS.WAREHOUSES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.WAREHOUSES),
    title: 'Склады',
    width: '330px',
    content: <></>,

    data: {
      prev: routes.organisations.path,
      next: routes.counterparties.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.counterparties.path) {
        navigate(routes.counterparties.path);
      }
    },
    id: TOUR_STEP_IDS.COUNTERPARTIES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.COUNTERPARTIES),
    title: 'Контрагенты',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.counterparties.path) {
        navigate(routes.counterparties.path);
      }

      const data = await queryClient.fetchQuery({
        queryKey: ['onboarding-data-status'],
        queryFn: getAccountCabinetOnboardingDataStatus,
      });

      if (!data.data.pnl_report_done)
        onboardingStore.setStepIndex(onboardingStore.currentStepIndex + 1);
    },
    id: TOUR_STEP_IDS.SECOND_STAGE_FINISH,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Второй этап завершён!',
    width: '330px',
    content: <></>,
  },

  ///////
  // Third Part
  ///////

  {
    before: async () => {
      if (window.location.pathname !== routes.counterparties.path) {
        navigate(routes.counterparties.path);
      }
    },
    id: TOUR_STEP_IDS.STAGE_3_INTRO,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Этап 3',
    width: '330px',
    content: <></>,
    data: {
      next: routes.banks.path,
    },
  },
  {
    before: async () => {
      const data = await queryClient.fetchQuery({
        queryKey: ['onboarding-data-status'],
        queryFn: getAccountCabinetOnboardingDataStatus,
      });

      if (!data.data.bank_upload_done) {
        navigate(routes.cashbox.path);
        await onboardingStore.jumpToStep(TOUR_STEP_IDS.CASHBOXES);
      } else if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }
    },
    id: TOUR_STEP_IDS.BANKS_AND_RULES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_AND_RULES),
    placement: 'center',
    title: 'Банки и правила',
    width: '525px',
    content: <></>,
    data: {
      prev: routes.counterparties.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }
    },
    id: TOUR_STEP_IDS.BANKS_ALL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_ALL),
    placement: 'center',
    title: 'Банки и правила',
    width: '525px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.BANKS_ALL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_ALL),
    // placement: 'center',
    title: 'Банки и правила',
    width: '1200px',
    content: <></>,
  },
  {
    before: async () => {
      const clicked = !!localStorage.getItem('clicked');

      if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }

      if (!clicked) {
        const element = document.querySelector(
          getStepTarget(TOUR_STEP_IDS.BANKS_ARTICLES)
        );
        if (element) {
          (element as HTMLElement)?.click();
          localStorage.setItem('clicked', 'true');
        }
      }
    },
    id: TOUR_STEP_IDS.BANKS_ARTICLES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_ARTICLES),
    title: 'Банки и правила',
    width: '330px',
    content: <></>,
    scrollOffset: 1000,
    //
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.BANKS_RULES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_RULES),
    title: 'Банки и правила',
    width: '330px',
    content: <></>,

    data: {
      next: routes.rules.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.rules.path) {
        navigate(routes.rules.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.RULES_ADD,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.RULES_ADD),
    title: 'Банки и правила',
    width: '330px',
    content: <></>,

    data: {
      prev: routes.banks.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.rules.path) {
        navigate(routes.rules.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.RULES_MODAL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.RULES_MODAL),
    title: 'Банки и правила',
    width: '1000px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.rules.path) {
        navigate(routes.rules.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.RULES_ALL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.RULES_ALL),
    title: 'Банки и правила',
    placement: 'center',
    width: '525px',
    content: <></>,
    data: {
      next: routes.banks.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.banks.path) {
        navigate(routes.banks.path);
      }
      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.BANKS_AFTER_RULES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.BANKS_AFTER_RULES),
    title: 'Банки и правила',
    placement: 'center',
    width: '525px',
    content: <></>,
    data: {
      prev: routes.rules.path,
      next: routes.cashbox.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.cashbox.path) {
        navigate(routes.cashbox.path);
      }

      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.CASHBOXES,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.CASHBOXES),
    title: 'Кассы',
    width: '330px',
    content: <></>,

    data: {
      prev: routes.banks.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.cashbox.path) {
        navigate(routes.cashbox.path);
      }

      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.CASHBOXES_MODAL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.CASHBOXES_MODAL),
    title: 'Кассы',
    width: '330px',

    content: <></>,
  },
  {
    before: async () => {
      localStorage.removeItem('clicked');
      if (onboardingStore.cashboxId === 0) {
        onboardingStore.setStepIndex(onboardingStore.currentStepIndex + 1);
      } else {
        const cashboxItemPath = `${routes.cashbox.path}item/?id=${onboardingStore.cashboxId}`;
        if (window.location.pathname !== cashboxItemPath) {
          navigate(cashboxItemPath);
        }
      }
    },
    id: TOUR_STEP_IDS.CASHBOXES_ADD,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.CASHBOXES_ADD),
    title: 'Кассы',
    width: '900px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.cashbox.path) {
        navigate(routes.cashbox.path);
      }

      localStorage.removeItem('clicked');
    },
    id: TOUR_STEP_IDS.CASHBOXES_ALL,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.CASHBOXES_ALL),
    placement: 'center',
    title: 'Кассы',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {},
    id: TOUR_STEP_IDS.TAXES_STAGE_3,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Налоги',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      const data = await queryClient.fetchQuery({
        queryKey: ['onboarding-data-status'],
        queryFn: getAccountCabinetOnboardingDataStatus,
      });

      if (
        !(
          data.data.pnl_report_done &&
          data.data.marketplaces.every((item) => item.done)
        )
      )
        onboardingStore.setStepIndex(onboardingStore.currentStepIndex + 1);
    },
    id: TOUR_STEP_IDS.FULL_PL_FINISH,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Вы собрали полный P&L!',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {},
    id: TOUR_STEP_IDS.FULL_DDS_FINISH,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Вы собрали полный ДДС!',
    width: '330px',
    content: <></>,
    data: {
      next: routes.acceptance.path,
    },
  },

  ///////
  // Forth Part
  ///////

  {
    before: async () => {
      if (window.location.pathname !== routes.acceptance.path) {
        navigate(routes.acceptance.path);
      }
    },
    id: TOUR_STEP_IDS.LOAD_INITIAL_REMAINS,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.LOAD_INITIAL_REMAINS),
    title: 'Начальные остатки',
    width: '330px',
    content: <></>,

    data: {
      next: routes.acceptance.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.acceptance.path) {
        navigate(routes.acceptance.path);
      }
    },
    id: TOUR_STEP_IDS.WAIT_FOR_INITIAL_REMAINS,
    overlayClickAction: false,
    target: 'body',
    placement: 'center',
    title: 'Подождите',
    width: '330px',
    content: <></>,

    data: {
      next: routes.acceptance.path,
    },
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.acceptance.path) {
        navigate(routes.acceptance.path);
      }
    },
    id: TOUR_STEP_IDS.OPEN_ACCEPTANCE,
    overlayClickAction: false,
    target: getStepTarget('orders-table'),
    title: 'Откройте приемку',

    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.acceptanceItem.path)
      ) {
        await moveToAcceptanceItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.DOWNLOAD_ACCEPTANCE_TEMPLATE,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.DOWNLOAD_ACCEPTANCE_TEMPLATE),
    title: 'Скачать шаблон',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.acceptanceItem.path)
      ) {
        await moveToAcceptanceItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.UPLOAD_ACCEPTANCE_TEMPLATE,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.UPLOAD_ACCEPTANCE_TEMPLATE),
    title: 'Загрузить шаблон',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.acceptanceItem.path)
      ) {
        await moveToAcceptanceItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.FILL_ACCEPTANCE_INFORMATION,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.FILL_ACCEPTANCE_INFORMATION),
    title: 'Заполните информацию',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.acceptanceItem.path)
      ) {
        await moveToAcceptanceItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.SAVE_ACCEPTANCE,
    overlayClickAction: false,
    target: `${getStepTarget(TOUR_STEP_IDS.SAVE_ACCEPTANCE)} ${getStepTarget(
      'save-button'
    )}`,
    title: 'Сохранить приемку',

    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.acceptance.path) {
        navigate(routes.acceptance.path);
      }
    },
    id: TOUR_STEP_IDS.SAVE_ALL_ACCEPTANCES,
    overlayClickAction: false,
    target: getStepTarget('orders-table'),
    // placement: 'center',
    title: 'Заполнить остальные приемки',
    width: '630px',
    content: <></>,
    data: {
      next: routes.shipment.path,
    },
  },

  {
    before: async () => {
      if (window.location.pathname !== routes.shipment.path) {
        navigate(routes.shipment.path);
      }
    },
    id: TOUR_STEP_IDS.OPEN_SHIPMENT,
    overlayClickAction: false,
    target: getStepTarget('orders-table'),
    title: 'Откройте отгрузку',

    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.shipmentItem.path)
      ) {
        await moveToShipmentItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.FILL_SHIPMENT_INFORMATION,
    overlayClickAction: false,
    target: getStepTarget(TOUR_STEP_IDS.FILL_SHIPMENT_INFORMATION),
    title: 'Заполните информацию',
    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (
        getPurchaseItemLocation(window.location.pathname) !==
        getPurchaseItemLocation(routes.shipmentItem.path)
      ) {
        await moveToShipmentItem({ navigate });
      }
    },
    id: TOUR_STEP_IDS.SAVE_SHIPMENT,
    overlayClickAction: false,
    target: `${getStepTarget(TOUR_STEP_IDS.SAVE_SHIPMENT)} ${getStepTarget(
      'save-button'
    )}`,
    title: 'Сохранить приемку',

    width: '330px',
    content: <></>,
  },
  {
    before: async () => {
      if (window.location.pathname !== routes.shipment.path) {
        navigate(routes.shipment.path);
      }
    },
    after: async () => {
      await accountCabinetOnboardingProgress({
        step_key: TOUR_STEP_IDS.SAVE_ALL_SHIPMENTS,
        finished: true,
      });
      onboardingStore.stopTour();
    },
    id: TOUR_STEP_IDS.SAVE_ALL_SHIPMENTS,
    overlayClickAction: false,
    target: getStepTarget('orders-table'),
    // placement: 'center',
    title: 'Заполнить остальные отгрузки',
    width: '630px',
    content: <></>,
  },
];
